import { render, staticRenderFns } from "./DeliveryDate.vue?vue&type=template&id=65094a83"
import script from "./DeliveryDate.vue?vue&type=script&lang=ts"
export * from "./DeliveryDate.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryDate.vue?vue&type=style&index=0&id=65094a83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports